module.exports = __webpack_public_path__ + "static/media/GFO_2022.f5950472.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2023/GFO_2022.pdf
// module id = 95
// module chunks = 0